import { useTheme } from "../../../context/useThemeContext";
import useAccountManagementStore from "../../../stores/accountManagementStore";
import { LoginButton } from "../components/LoginButton";

export default function CustomMessage(props: {
    pageHeaderText: string;
    pageText: string;
    subText?: string;
}) {
    const { theme } = useTheme();

    const { setLoginState } = useAccountManagementStore();

    return (
        <form
            id="signOutForm"
            className="flex flex-col p-9 pb-7 text-center text-white"
            onSubmit={(e) => e.preventDefault()}
        >
            <b className="mb-4 text-2xl">{props.pageHeaderText}</b>

            <div style={{ color: theme.fontColor[100] }}>
                <p>{props.pageText}</p>
            </div>
            <div className="mb-3" />
            {props.subText && (
                <u
                    className="pt-2 text-xs"
                    style={{ color: theme.fontColor[100] }}
                >
                    {props.subText}
                </u>
            )}
            <LoginButton
                type="submit"
                className="mb-1 mt-4 h-[36px] rounded text-sm"
                style={{
                    backgroundColor: theme.accentColor,
                }}
                onClick={() => setLoginState("default")}
            >
                Return
            </LoginButton>
        </form>
    );
}
